module.exports = __webpack_public_path__ + "img/quality@2x.ce7372c.jpg";